import { ChangeEvent, Dispatch, SetStateAction, useState } from 'react';
import FormGroup from '../../../../components/FormGroup';
import Input from '../../../../components/Input';
import MyModal from '../../../../components/Modal';
import useErrors from '../../../../hooks/useErrors';
import formatCpf from '../../../../utils/formatCpf';
import isCpfvalid from '../../../../utils/isCpfValid';

interface ISearchByCpfModal {
  searchByCpfModalShow: boolean;
  setSearchByCpfModalShow: Dispatch<SetStateAction<boolean>>;
  searchByCpf: (cpf: string) => Promise<void>;
}

export default function SearchByCpfModal({
  searchByCpfModalShow,
  setSearchByCpfModalShow,
  searchByCpf,
}: ISearchByCpfModal) {
  const [cpf, setCpf] = useState('');

  const { setError, removeError, getErrorMessageByFieldName, errors } = useErrors();

  function handleCpfChange(event: ChangeEvent<HTMLInputElement>) {
    setCpf(formatCpf(event.target.value));

    if (!isCpfvalid(formatCpf(event.target.value))) {
      setError({ field: 'cpf', message: 'CPF inválido' });
    } else {
      removeError('cpf');
    }
  }

  const isValidToSearchByCpf = cpf && errors.length === 0;

  return (
    <MyModal
      show={searchByCpfModalShow}
      title={'Pesquisar por CPF'}
      closeButtonLabel="Fechar"
      actionButtonLabel={'Pesquisar'}
      onClose={() => setSearchByCpfModalShow(false)}
      onAction={() => searchByCpf(cpf)}
      isActionButtonDisabled={!isValidToSearchByCpf}
      type="action"
      size='lg'
      modalBody={(
        <FormGroup error={getErrorMessageByFieldName('cpf')}>
          <label htmlFor="contactName">Digite o CPF</label>
          <Input
            value={cpf}
            onChange={handleCpfChange}
            placeholder="XXX.XXX.XXX-XX"
            error={getErrorMessageByFieldName('cpf')}
            maxLength={14}
          />
        </FormGroup>
      )}
    />
  );
}
